import { Timestamp } from "firebase/firestore";

export enum EmergencyCall {
  POLICE = "POLICE",
  EMERGENCY_FIRE = "EMERGENCY_FIRE",
  EMERGENCY_MEDICAL = "EMERGENCY_MEDICAL",
  CONTACT_REPORTING_ONLY = "CONTACT_REPORTING_ONLY",
}

export enum EmergencyCallGerman {
  POLICE = "Polizei / 110",
  EMERGENCY_FIRE = "Feuerwehr / 112",
  EMERGENCY_MEDICAL = "Notarzt / 112",
  CONTACT_REPORTING_ONLY = "Interner Alarm",
}

export enum IncidentStatus {
  IN_PROGRESS = "IN_PROGRESS",
  FAILED = "FAILED",
  PARTIALLY_FAILED = "PARTIALLY_FAILED",
  SUCCESS = "SUCCESS",
  AUTOCLOSED = "AUTOCLOSED",
}

export enum IncidentStatusGerman {
  IN_PROGRESS = "In Übermittlung",
  FAILED = "Fehlgeschlagen",
  PARTIALLY_FAILED = "Teilweise fehlgeschlagen",
  SUCCESS = "Übermittelt",
  AUTOCLOSED = "AUTOCLOSED",
}

export type Incident = {
  id: string;
  openTime: string;
  created?: Timestamp;
  deviceId: string;
  deviceTestMode: boolean;
  invokerTaskId: string;
  deviceName: string;
  scenarioId: string;
  scenarioTitle: string;
  scenarioDetails: string;
  emergencyCall: EmergencyCall;
  status: IncidentStatus;
  exactPosition?: string;
  totalDeliveries?: number;
  failedDeliveries?: number;
};
